export default function htmlDecode(value) {
  const doc = new DOMParser().parseFromString(value, 'text/html');
  return doc.documentElement.textContent;
}
